import React from "react";
import classes from "./MainTitle.module.css";

const MainTitle = (props) => (
  <div className={classes.titleContainer}>{props.children}</div>
);

export default MainTitle;
